// logto-instance.ts
let logtoInstance: any | null = null

export function setLogtoInstance(instance: any) {
  logtoInstance = instance
}

export function getLogtoInstance() {
  if (!logtoInstance) {
    throw new Error('Logto not initialized')
  }

  return logtoInstance
}
